import React from 'react'
import { Carousel } from 'react-bootstrap'

class BVUpsellBanner extends React.PureComponent {
	populateItems() {
		let items = []
		for (let i = 1; i <= 7; i += 1) {
			items.push(<Carousel.Item>
				<a
					target="_blank"
					href="https://www.malcare.com/pricing/?utm_source=migrate_guru&utm_medium=during_migration&utm_campaign=security_banner&ref=mg_progress&loc=30OFFMG"
					rel="noopener noreferrer"
				>
					<img src={`/assets/mg-banner/${i}.png`} className="img-responsive"/>
				</a>
			</Carousel.Item>)
		}
		return items 
	}
	render() {
		return <div className="col-md-9 col-xs-9 center-dom">
			<div className="row" style={{ backgroundColor: "#edf3fa" }}>
				<div className="col-md-8" id="mg-banner-div" style={{padding: "0"}}>
					<img src="/assets/mg-banner/left-banner.png" className="img-responsive"/>
				</div>
				<div className="col-md-4" style={{padding: "0"}}>
					<Carousel controls={false} interval={6000} slide={true}>
						{this.populateItems()}
					</Carousel>
				</div>
			</div>
			<div className="row">
				<img src="/assets/mg-banner/footer.png" className="img-responsive"/>
			</div>
		</div>
	}
}

export default BVUpsellBanner
